import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import BillsArchive from "./components/Home";
import BillViewer from "./components/BillViewer";
import Navigation from "./components/Nav";
import KnoxPage from "./components/knox/KnoxPage";
import CountyElectionPage from "./components/elections/CountyElectionPage";
import NovemberElectionPage from "./components/elections/NovemberElectionPage";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css";
import "./components/elections/NovemberElectionPage.css";
import rawHbData from "./data/hb_data.json";

function extractCategory(abstract) {
  if (!abstract) return null;
  const dashIdx = abstract.indexOf(' - ');
  if (dashIdx === -1) return null;
  const candidate = abstract.slice(0, dashIdx).trim();
  // Reject if the candidate looks like the start of a sentence (too long or contains lowercase words)
  if (candidate.length > 80) return null;
  return candidate;
}

function normalizeBill(bill) {
  return {
    bill_number: bill.bill_number,
    title: bill.abstract || "",
    sponsor: bill.primeSponsor ? bill.primeSponsor.replace(/^by \*/i, "").trim() : "",
    description: bill.abstract || "",
    summary: bill.explanations?.explanation || "",
    layman_summary: bill.explanations?.eli5 || "",
    impact_analysis: bill.explanations?.impact || "",
    companionBill: bill.companionBill || null,
    filedDate: bill.filedDate || null,
    impactScore: bill.explanations?.impactScore ?? null,
    category: extractCategory(bill.abstract),
  };
}

const sortByNumber = (a, b) =>
  parseInt(a.bill_number.replace(/\D/g, "")) - parseInt(b.bill_number.replace(/\D/g, ""));

const hbBillsData = rawHbData.map(normalizeBill).sort(sortByNumber);

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Routes>
          <Route
            path="/"
            element={<NovemberElectionPage />}
          />
          <Route path="/bills" element={<BillsArchive hbBillsData={hbBillsData} />} />
          <Route path="/knox" element={<KnoxPage />} />
          <Route path="/elections/tn" element={<NovemberElectionPage />} />
          <Route path="/elections/tn/:countySlug" element={<NovemberElectionPage />} />
          <Route path="/elections/tn/august-2026" element={<CountyElectionPage />} />
          <Route path="/elections/tn/august-2026/:countySlug" element={<CountyElectionPage />} />
          <Route path="/:bill_id" element={<BillViewer allBillsData={hbBillsData} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
